/**
 * @author xyguo
 * @description 主持人列表
 * @Date 2020/10/20
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool,utils_tool ,component_tool} from '@/tool'
import moment from "moment";

let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
let {  WizBrowserExport } = component_tool;
let {Session , Storage} = utils_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD HH:mm') : '';
}

class HostHktList extends WizContainer {

  componentName = 'hostHktList';

  constructor(props) {
    super(props);
    this.state = {}
    let personId = Storage.getStorage('user') && Storage.getStorage('user').personId;
    let isAdmin = '1cdf270fdc764dfb91634d3b2f48257f'===personId;
    this.isAdmin = isAdmin
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          //val['name'] = checkStrLength(val['name'], len);
          val['startDate'] = formatterDate(val['startDate'])
          val['endDate'] = formatterDate(val['endDate'])
        });
      }
      f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleGetUrlData(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      window.open(o['data'], '_blank')
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '直播课堂名称',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'stateStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '讲师',
        field: 'hostName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']

      let f = (v) => {
        v && v.forEach(val => {
          val['startDate'] = formatterDate(val['startDate'])
          val['endDate'] = formatterDate(val['endDate'])
        });
      }
      f(data)
      WizBrowserExport({
        title: '直播课堂',
        sheetName: '直播课堂',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '直播课堂.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig : templateConfig(this.isAdmin),
      apiDataFormat: {
        list: this._handleListData,
        getUrl: this._handleGetUrlData,
        getWebUploadBackPlayUrl: this._handleGetUrlData,
        export : this._handleFile,
        setInteractLiveState: this._handleCMD,
      },

})
return <WizReduxTemplate {..._reduxTemplateCofig}  />
}
}


const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(HostHktList);
